function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Modal from '@rd-web-markets/shared/dist/util/Modal';
import React, { useCallback, useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import debounce from 'lodash.debounce';
import { useMemo } from 'react';
import { EDITOR_CLAIM_GROUP_DYNAMIC_FIELDS, EDITOR_CLAIM_SPECIFIC_DYNAMIC_FIELDS } from '@rd-web-markets/market/dist/constants';
import claimGroupService from '@rd-web-markets/shared/dist/services/claim_group.service';
import ReviewableFieldEditor from '@rd-web-markets/shared/dist/util/textEdit/ReviewableFieldEditor';
import { getReportTemplateOptions } from '@rd-web-markets/shared/dist/util/tinyMceConfig';
import OnlyCommentsEditor from '@rd-web-markets/shared/dist/util/textEdit/OnlyCommentsEditor';
import reportTemplateService from '../../services/report_template.service';
export default function EditClaimGroupFieldModal(_ref) {
  let {
    claimGroupId,
    fieldName,
    reportTemplateId,
    onHide,
    onContentChanged,
    isVisible,
    title,
    isUnderReview = false,
    footnoteStartIndex = 0
  } = _ref;
  const [rndReportTemplate, setRndReportTemplate] = useState(null);
  const [editText, setEditText] = useState({});
  const [apiUpdateResult, setApiUpdateResult] = useState({});
  const [highlightsText, setHighlightsText] = useState(null);
  const [textLoaded, setTextLoaded] = useState(false);
  const [closeButtonLoading, setCloseButtonLoading] = useState(false);
  const [reportTextWasChanged, setReportTextWasChanged] = useState(false);
  const [claimGroup, setClaimGroup] = useState(null);
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const showTrackChangesControls = user.account_type !== 'customer';

  /**
   * 
   * @param {*} editText always provided
   * @param {*} highlightText always provided
   * @param {*} editableTitle only if editing a project report slice
   * @param {*} projectReportSlice 
   * @param {*} rndReportTemplate 
   */
  const setEditData = useCallback(function (newEditText, newHighlightText) {
    let newReportTemplateCategory = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    // setReportTemplateCategory({ ...newReportTemplateCategory })

    setEditText(newEditText);
    setHighlightsText(newHighlightText);
  }, []);
  useEffect(() => {
    const setText = async () => {
      try {
        // only used for the editor settings
        const rndReportTemplate = await reportTemplateService.get(reportTemplateId);
        setRndReportTemplate(rndReportTemplate);
        const claimGroupResult = await claimGroupService.get(claimGroupId);
        setClaimGroup(claimGroupResult);
        const editText = {
          content: claimGroupResult[fieldName],
          timeOfUpdate: null
        };
        const highlightText = claimGroupResult[fieldName];
        setEditData(editText, highlightText, {});
        setTextLoaded(true);
      } catch (error) {
        dispatch(handleError(error));
      }
    };
    setText();
  }, [claimGroupId, dispatch, fieldName, reportTemplateId, setEditData]);
  const debouncedUpdateReportText = useMemo(() => {
    setReportTextWasChanged(true);
    const updateClaimGroupField = async (text, timeOfUpdate) => {
      const updatedClaimGroup = await claimGroupService.update(_objectSpread(_objectSpread({}, claimGroup), {}, {
        [fieldName]: text
      }));
      setApiUpdateResult({
        editDataParams: [{
          content: updatedClaimGroup[fieldName]
        }, updatedClaimGroup[fieldName], _objectSpread({}, updatedClaimGroup)],
        timeOfUpdate
      });
      setClaimGroup(updatedClaimGroup);
    };
    return debounce(async (text, timeOfUpdate) => {
      try {
        await updateClaimGroupField(text, timeOfUpdate);
        setCloseButtonLoading(false);
      } catch (error) {
        console.log(error);
        dispatch(handleError(error));
      }
    }, 1000);
  }, [claimGroup, fieldName, dispatch]);
  useEffect(() => {
    if (editText.timeOfUpdate) {
      if (editText.timeOfUpdate > apiUpdateResult.timeOfUpdate || !apiUpdateResult.timeOfUpdate) {
        debouncedUpdateReportText(editText.content, editText.timeOfUpdate);
      } else if (apiUpdateResult.timeOfUpdate && apiUpdateResult.timeOfUpdate >= editText.timeOfUpdate) {
        setEditData(...apiUpdateResult.editDataParams);
      }
    }
  }, [apiUpdateResult, debouncedUpdateReportText, editText, setEditData]);
  const modalBody = () => {
    if (!textLoaded) {
      return /*#__PURE__*/React.createElement(Loader, null);
    }
    return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, user.account_type === 'customer' && !claimGroup.active_change_set.finalized_at && /*#__PURE__*/React.createElement(OnlyCommentsEditor, {
      getContentFn: () => editText.content,
      updateContentFn: content => {
        const timeOfUpdate = Date.now();
        setEditText({
          content,
          timeOfUpdate
        });
        setCloseButtonLoading(true);
      },
      modelClass: "ClaimGroup",
      modelId: claimGroupId
    }), user.account_type === 'customer' && !!claimGroup.active_change_set.finalized_at && /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: editText.content
      }
    }), user.account_type !== 'customer' && /*#__PURE__*/React.createElement(ReviewableFieldEditor, {
      isUnderReview: isUnderReview,
      editorContent: editText.content,
      modelClass: "ClaimGroup",
      modelId: claimGroupId,
      modelField: fieldName,
      editorInitConfig: getReportTemplateOptions(rndReportTemplate, EDITOR_CLAIM_GROUP_DYNAMIC_FIELDS, EDITOR_CLAIM_SPECIFIC_DYNAMIC_FIELDS, {
        footnoteStartIndex
      }),
      trackChangesOnCreateComment: content => {
        const timeOfUpdate = Date.now();
        setEditText({
          content,
          timeOfUpdate
        });
        setCloseButtonLoading(true);
      },
      trackChangesEditoInitFn: addCommentCallback => getReportTemplateOptions(rndReportTemplate, EDITOR_CLAIM_GROUP_DYNAMIC_FIELDS, EDITOR_CLAIM_SPECIFIC_DYNAMIC_FIELDS, {
        isTrackingChanges: true,
        onAddCommentButtonClickCallback: addCommentCallback,
        showTrackChangesControls: showTrackChangesControls,
        footnoteStartIndex
      }),
      onEditorChange: content => {
        const timeOfUpdate = Date.now();
        setEditText({
          content,
          timeOfUpdate
        });
        setCloseButtonLoading(true);
      },
      showTrackChangesControls: showTrackChangesControls
    })));
  };
  return /*#__PURE__*/React.createElement(Modal, {
    size: "xl",
    title: title || 'Edit text',
    show: isVisible,
    renderBody: modalBody,
    onHide: onContentChanged,
    closeButtonLoading: closeButtonLoading,
    disabled: closeButtonLoading,
    closeText: "Save"
  });
}